const Validations = {
  checkNetConnection: async () => {
    let isConnected = window.navigator.onLine;
    if (isConnected) {
      return true;
    } else {
      return false;
    }
  },
  isNameValid: (name: any) => {
    const trimmedTitle = name?.trim();
    const isValidLength = trimmedTitle.length >= 3 && trimmedTitle.length <= 50;
    if (!isValidLength) {
      return {
        isValid: isValidLength,
        message: ' length must be in between 3 to 50 Character.',
      };
    }
    const pattern = /^[a-zA-Z0-9\s]+$/;
    const isCharValid = pattern.test(name);
    if (!isCharValid) {
      return {
        isValid: isCharValid,
        message: 'Only Alphanumeric characters and spaces are allowed.',
      };
    }
    return {
      isValid: true,
      message: '',
    };
  },
  validateEmail: (email: string) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  },
  allowOnlyNumbers: (value: string) => {
    const pattern = /^[0-9]+$/;
    if (pattern.test(value.trim())) {
      return true;
    } else {
      return false;
    }
  },
  allowOnlyAlphabets: (value: string) => {
    const pattern = /^[a-zA-Z\s]+$/;
    if (pattern.test(value)) {
      return true;
    } else {
      return false;
    }
  },
  allowNumberAndFloat: (value: string) => {
    const pattern = /^\s*([\d,]+(\.[\d,]*)?|\.[\d,]+)?\s*$/;
    //  const pattern = /^\s*(\d+(\.\d*)?|\.\d+)?\s*$/;
    if (pattern.test(value)) {
      return true;
    } else {
      return false;
    }
  },
  validateAge: async (value: string) => {
    const pattern = /^\d{0,2}(\.\d{0,2})?$/;
    if (pattern.test(value.trim())) {
      return true;
    } else {
      return false;
    }
  },
  validatePincode: async (value: string) => {
    const pattern = /^\d{0,6}(\.\d{0,2})?$/;
    if (pattern.test(value.trim())) {
      return true;
    } else {
      return false;
    }
  },
};
export default Validations;
